import { RESCHEDULE_TOKEN_PARAM } from '@features/blockit-link/constants';

const MEETING_LINK_PATH = /^\/link\/[^/]+\/[^/]+\/([^/]+)\/?$/;

const storageKeyFor = (meetingId: string): string => {
  return `blockit-link:reschedule-token:${meetingId}`;
};

/** Storage can be unavailable (private mode, blocked site data); the caller then leaves the token where it found it. */
const store = (meetingId: string, token: string): boolean => {
  try {
    window.sessionStorage.setItem(storageKeyFor(meetingId), token);
    return true;
  } catch {
    return false;
  }
};

const read = (meetingId: string): string | undefined => {
  try {
    return window.sessionStorage.getItem(storageKeyFor(meetingId)) ?? undefined;
  } catch {
    return undefined;
  }
};

/**
 * Runs at bootstrap, before telemetry initialises and before the router reads the location: from that point
 * on nothing that looks at `location` sees the credential, and the tab keeps it so a reload still works.
 * If storage refuses the write the token stays in the URL, where the route loader still reads it.
 */
const stashFromUrl = (): void => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(RESCHEDULE_TOKEN_PARAM);
  const meetingId = url.pathname.match(MEETING_LINK_PATH)?.[1];
  if (!(token && meetingId)) {
    return;
  }
  if (!store(meetingId, token)) {
    return;
  }
  url.searchParams.delete(RESCHEDULE_TOKEN_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());
};

export const RescheduleTokenStore = {
  stashFromUrl,
  read,
};
